export function SizeL(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path fill="currentColor" d="M9 7v10h6v-2h-4V7z"></path>
    </svg>
  )
}
